import { Component } from "@angular/core";
import {
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "Time Tracking";
  loadingModule = false;
  constructor(private router: Router) {
    router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.loadingModule = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingModule = false;
      }
    });
  }
}
